import { ASSESSMENT, LESSON } from 'global/constants';
import { EVENT_CATEGORY_CLASS_TODO } from 'approot/shared/data-tracker/data-events.constants';
import { pushDataTrackerEvent } from 'approot/shared/data-tracker/data-tracker-push';
import { DataEventAttrs } from 'approot/shared/data-tracker/data-tracker.constants';

export function handleCheckboxChange(value: string, source: number[]) {
  return source.includes(Number(value))
    ? source.filter(p => p !== Number(value))
    : [...source, Number(value)];
}

export function handleSectionIdCheckboxChange(value: string, source: string[]) {
  return source.includes(value)
    ? source.filter(p => p !== value)
    : [...source, value];
}

export function pushAssignDataEvent({
  contentId,
  contentType,
  data,
}: {
  contentId: number;
  contentType: typeof LESSON | typeof ASSESSMENT;
  data: DataEventAttrs;
}) {
  pushDataTrackerEvent(EVENT_CATEGORY_CLASS_TODO, 'assign', {
    target_type: contentType,
    target_identifier: contentId,
    ...data,
  });
}

export function pushUnassignDataEvent({
  contentId,
  contentType,
}: {
  contentId: number;
  contentType: typeof LESSON | typeof ASSESSMENT;
}) {
  pushDataTrackerEvent(EVENT_CATEGORY_CLASS_TODO, 'unassign', {
    target_type: contentType,
    target_identifier: contentId,
  });
}
